import {Async, fromResult, Loaded} from 'Core/models/Async';
import {Email, UnvalidatedEmail, ValidEmail} from 'Core/models/Email';
import {EmptyString, StringUnion} from 'Core/models/EmptyString';
import {createAction} from 'Shared/utilities/actionCreator';
import unionize, {ofType, UnionOf} from 'unionize';

export enum UsernameRecoveryActionTypes {
  RECOVER_USERNAME = 'usernameRecovery/RECOVER_USERNAME',
  CHANGE_EMAIL = 'usernameRecovery/CHANGE_EMAIL',
  CLEAR = 'usernameRecovery/CLEAR',
}

type RecoveryEmailSubmitted = {};
export const UserEmailRecoveryAddress = unionize({
  email: ofType<Async<Email>>(),
  recoveryEmailSent: ofType<Loaded<RecoveryEmailSubmitted>>(),
});
export type UserEmailRecoveryAddress = UnionOf<typeof UserEmailRecoveryAddress>;

export const recoverUsername = (email: ValidEmail) =>
  createAction(UsernameRecoveryActionTypes.RECOVER_USERNAME, {email});
export const changeEmail = (email: UserEmailRecoveryAddress) =>
  createAction(UsernameRecoveryActionTypes.CHANGE_EMAIL, {email});
export const clear = () => createAction(UsernameRecoveryActionTypes.CLEAR);

type UsernameRecoveryAction = ReturnType<typeof changeEmail> | ReturnType<typeof clear>;

type UsernameRecoveryState = {
  username: StringUnion;
  email: UserEmailRecoveryAddress;
};

export const DEFAULT_STATE: UsernameRecoveryState = {
  username: new EmptyString(),
  email: UserEmailRecoveryAddress.email(fromResult(new UnvalidatedEmail(''))),
};

export default (state = DEFAULT_STATE, action: UsernameRecoveryAction): UsernameRecoveryState => {
  switch (action.type) {
    case UsernameRecoveryActionTypes.CHANGE_EMAIL:
      return {
        ...state,
        email: action.payload.email,
      };
    case UsernameRecoveryActionTypes.CLEAR:
      return DEFAULT_STATE;
    default:
      return state;
  }
};
